import styled from 'styled-components'
import backgroundBanner from 'assets/images/apresentacao/background_verde_v2.png'
import introducaoProduto from 'assets/images/apresentacao/introducao-produto.png'

export const ApresentacaoLayoutWrapper = styled.section`
  display: flex;
  flex-direction: column;
`

export const BannerWrapper = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 450px;
  height: 100%;

  & .infos {
    justify-content: center;
    display: flex;
    flex-direction: column;
    max-width: 700px;
    padding: 0 50px;
    width: 100%;

    & h2,
    h3 {
      font-weight: 700;
      line-height: 54px;
    }

    & h2 {
      font-size: 48px;
      color: var(--roxo-riber);
    }

    & h3 {
      font-size: 32px;
      color: var(--branco);
    }
  }

  & .img-banner {
    margin-right: 100px;
  }

  @media screen and (max-width: 1200px) {
    justify-content: center;
    margin-top: 50px;

    & .infos {
      align-items: center;

      & h2,
      h3 {
        font-weight: 700;
        line-height: 35px;
        text-align: center;
      }

      & h2 {
        font-size: 30px;
      }

      & h3 {
        font-size: 25px;
      }
    }

    & .img-banner {
      display: none !important;
    }
  }

  & .infos-credito-consignado {
    display: flex;
    justify-content: center;
    width: 100%;
    & .container-produto {
      display: flex;
      color: #8d8d8d;
      justify-content: space-between;
      width: 100%;
      margin-top: 20px;
    }

    & h1 {
      font-size: 57.6px;
      font-weight: 800;
      text-align: center;
      color: #4c4c4c;
    }

    h2 {
      font-size: 28px;
      font-weight: 500;
      text-align: center;
      color: #4c4c4c;
    }

    & ul {
      list-style: none;
      padding: 0;
      margin: 0;
      color: #4c4c4c;

      & li {
        font-size: 20px;
        line-height: 25px;
        font-weight: 500;
        color: #4c4c4c;
      }
    }

    & .img-banner-produto {
      max-width: 450px;
    }

    & .warning {
      display: flex;
      flex-direction: column;
      font-size: 16px;
      color: #4c4c4c;
    }

    @media screen and (max-width: 991px) {
      & h1 {
        font-size: 30px;
      }

      h2 {
        font-size: 20px;
      }

      & ul li {
        font-size: 18px;
      }

      & .img-banner-produto {
        max-width: 300px;
      }
    }

    @media screen and (max-width: 768px) {
      & h1 {
        font-size: 25px;
      }

      h2 {
        font-size: 18px;
      }

      & ul li {
        font-size: 16px;
      }

      & .img-banner-produto {
        max-width: 250px;
      }
    }
  }

  .infos-cartao-consignado {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 40px;
    width: 100%;

    .container-produto {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    h1 {
      font-size: 50px;
      font-weight: 700;
      text-align: center;
      color: #414141;
      margin: 0 0 20px;
    }

    h2 {
      font-size: 34px;
      font-weight: 700;
      text-align: start;
      color: #363336;
      border-radius: 10px;
      background-color: rgb(111, 225, 139);
      margin: 0;
      width: fit-content;
      line-height: 1.1;

      &.linha-1 {
        border-radius: 10px 10px 10px 0;
        padding: 10px 10px 0;
      }

      &.linha-2 {
        border-radius: 0 0 10px 10px;
        padding: 0 10px 10px;
      }
    }

    .img-banner-produto {
      max-width: 600px;
      width: 100%;
      height: auto;
    }

    .tips {
      color: #414141;
      font-size: 1rem;
      font-weight: 700;
      list-style: none;
      padding-left: 0;

      .icon {
        margin-right: 10px;
        font-size: 12px;
      }
    }

    @media screen and (max-width: 991px) {
      h1 {
        font-size: 40px;
      }

      h2 {
        font-size: 28px;
      }

      .img-banner-produto {
        max-width: 500px;
      }
    }

    @media screen and (max-width: 768px) {
      gap: 30px;

      h1 {
        font-size: 35px;
        margin-bottom: 15px;
      }

      h2 {
        font-size: 24px;
        background-color: transparent;
        padding: 0;
        border-radius: 0;
        width: auto;

        &.linha-1,
        &.linha-2 {
          background-color: rgb(111, 225, 139);
          line-height: 1.2;
          width: fit-content;
        }

        &.linha-1 {
          padding: 8px 8px 0;
        }

        &.linha-2 {
          padding: 0 8px 8px;
        }
      }

      .img-banner-produto {
        max-width: 400px;
      }
    }

    @media screen and (max-width: 480px) {
      gap: 25px;

      h1 {
        font-size: 28px;
        margin-bottom: 10px;
      }

      h2 {
        font-size: 20px;

        &.linha-1,
        &.linha-2 {
          line-height: 1.3;
          padding: 6px 6px 0;
        }

        &.linha-2 {
          padding: 0 6px 6px;
        }
      }

      .container-produto {
        flex-direction: column;
        gap: 15px;
      }

      .img-banner-produto {
        max-width: 300px;
      }

      .tips {
        font-size: 0.85rem;
      }
    }
  }
  & .infos-credito-pessoal {
    display: flex;
    justify-content: center;
    width: 100%;
    & .container-produto {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    & h1 {
      font-size: 3rem;
      line-height: 52px;
      font-weight: 700;
      text-align: center;
      color: #4c4c4c;
    }

    h2 {
      font-size: 1.7rem;
      font-weight: 700;
      text-align: center;
      color: #4c4c4c;
    }

    & .img-banner-produto {
      max-width: 600px;
      border-radius: 20px;
      margin-bottom: 20px;
    }

    & .w-600 {
      max-width: 600px;
    }

    & .card-possibilidades {
      color: #414141;
      border: 1px solid #414141;
      border-radius: 25px;
      font-weight: 700;
      padding: 20px;
      max-width: 300px;
      min-height: 80px;
      display: flex;
      align-items: center;

      & .icon {
        margin-right: 10px;
      }

      & span {
        font-size: 16px;
      }
    }

    @media screen and (max-width: 991px) {
      & h1 {
        font-size: 40px;
      }

      h2 {
        font-size: 25px;
      }

      & .img-banner-produto {
        max-width: 500px;
      }
    }

    @media screen and (max-width: 768px) {
      & h1 {
        font-size: 35px;
      }

      h2 {
        font-size: 22px;
      }

      & .img-banner-produto {
        max-width: 400px;
      }
    }
  }

  & .infos-fgts {
    display: flex;
    justify-content: center;
    width: 100%;
    & .container-produto {
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin-top: 30px;
    }

    & h1 {
      font-size: 50px;
      line-height: 52px;
      font-weight: 700;
      text-align: center;
      color: #4c4c4c;
    }

    h2 {
      font-size: 30px;
      font-weight: 500;
      text-align: center;
      color: #4c4c4c;
    }

    & .img-banner-produto {
      max-width: 500px;
      border-radius: 20px;
      margin-bottom: 20px;
    }

    & .card-possibilidades {
      color: #414141;
      border: 1px solid #414141;
      border-radius: 25px;
      font-weight: 700;
      padding: 20px;
      max-width: 300px;
      min-height: 80px;
      display: flex;
      align-items: center;

      & .icon {
        margin-right: 10px;
      }

      & span {
        font-size: 16px;
      }
    }

    & .tips {
      color: #414141;
      font-size: 1rem;
      font-weight: 700;
      text-align: center;

      & .icon {
        margin-right: 10px;
        font-size: 12px;
      }
    }

    @media screen and (max-width: 991px) {
      & h1 {
        font-size: 40px;
      }

      h2 {
        font-size: 25px;
      }

      & .img-banner-produto {
        max-width: 400px;
      }
    }

    @media screen and (max-width: 768px) {
      & h1 {
        font-size: 35px;
      }

      h2 {
        font-size: 22px;
      }

      & .img-banner-produto {
        max-width: 300px;
      }
    }
  }

  & .infos-credito-consignado,
  & .infos-cartao-consignado,
  & .infos-credito-pessoal,
  & .infos-fgts {
    min-height: calc(100vh - 60px);
  }
`

export const ArticleWrapper = styled.article`
  & .grid {
    display: flex;
    max-width: 1200px;

    & > * {
      & h4 {
        color: var(--roxo-riber);
        font-size: 40px;
        font-weight: 700;
      }

      & p {
        color: var(--dark-gray);
        font-size: 16px;
      }

      & img {
        max-width: 400px;
        width: 100%;
      }
    }
  }
`
export const SimulacaoWrapper = styled.section`
  background-image: linear-gradient(
      to right top,
      #00ab4f44,
      #00b25344,
      #00ba5644,
      #00c15a44,
      #00c95e44
    ),
    url(${introducaoProduto});
  background-color: #c0bccc;
  background-position: 95% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  height: 840px;
  justify-content: center;
  max-height: 840px;
  padding: 40px 80px;

  & h2 {
    color: var(--roxo-riber);
    font-size: 48px;
    font-weight: 700;
  }

  & h3 {
    color: var(--branco);
    font-size: 40px;
    font-weight: 700;
  }
`

export const CardSimulacao = styled.div`
  align-items: center;
  background: var(--branco);
  border-radius: 30px;
  box-shadow: 0px 0px 5.41032px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  height: fit-content;
  max-width: 600px;
  padding: 20px;
  row-gap: 15px;
  width: 100%;

  & .titulos {
    align-items: center;
    display: flex;
    flex-direction: column;

    & label {
      color: var(--verde-riber);
      font-weight: 700;
      font-size: 28px;
      line-height: 40px;
    }

    & span {
      color: var(--preto-riber);
      font-weight: 700;
      font-size: 20px;
      line-height: 30px;
    }
  }
`
interface FaqWrapperProps {
  backgroundImage: string
}

export const FaqWrapper = styled.aside<FaqWrapperProps>`
  background: url(${backgroundBanner}),
    url(${(props) => props.backgroundImage}) no-repeat center;
  background-size: cover;
  display: flex;
  justify-content: space-around;
  padding: 80px;

  .img-faq {
    width: 600px;
    object-fit: contain;
  }

  & .faq {
    display: flex;
    flex-direction: column;
    gap: 40px;
    max-width: 600px;

    & div {
      flex-direction: column;
      gap: 40px;
    }

    & h3 {
      color: var(--branco);
      font-weight: 700;
      font-size: 27px;
      text-align: center;
    }
  }

  @media screen and (max-width: 1200px) {
    .img-faq {
      width: 400px;
    }
  }

  @media screen and (max-width: 991px) {
    background-image: url(${(props) => props.backgroundImage}),
      url(${backgroundBanner});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 600px, cover;
    justify-content: center;
  }

  @media screen and (max-width: 768px) {
    background-size: 400px, cover;
  }
`

export const CardFaq = styled.div`
  background: var(--light-gray);
  border-radius: 20px;
  display: flex;
  padding: 10px 20px;
  width: 100%;

  & label {
    align-items: center;
    color: var(--preto-riber);
    display: flex;
    font-weight: 400;
    font-size: 18px;
    gap: 10px;
    justify-content: space-between;
    line-height: 32px;

    & .icon {
      min-width: 40px;
    }
  }

  & p {
    color: var(--preto-riber);
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
  }
`

export const StepCarouselWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & ul {
    list-style: none;
    padding: 0;
    margin: 0;
    margin-bottom: 20px;

    & li {
      font-size: 1rem;
      line-height: 1.2rem;
      font-weight: 500;
      margin-bottom: 10px;
      margin-top: 10px;
    }
  }

  & .custom-badge {
    padding: 10px 20px;
    background: #4c4c4c;
    border-radius: 20px;
    width: fit-content;
    color: var(--branco);
    font-weight: 700;
    margin-bottom: 20px;
  }
`
